import React, { useState } from 'react';

import { RestaurantResponse } from '@/api/lib/restaurant';

import { ValidationStatusHistory } from '../ValidationStatusHistory';
import { Typography } from '@/components/atoms/Typography';
import { Button } from '@/components/molecules/Button';

interface Props {
  restaurant: RestaurantResponse;
  onDelete: () => void;
  isLoading: boolean;
}

export const ProposalRestaurantSideInfos = ({ restaurant, onDelete, isLoading }: Props) => {
  const [showConfirmation, setShowConfirmation] = useState(false);

  const latestSupportComment = restaurant.validationStatusHistory
    .filter((entry) => entry.authorRole === 'support')
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())[0]?.comment;

  const handleDeleteClick = () => {
    setShowConfirmation(true);
  };

  const handleCancel = () => {
    setShowConfirmation(false);
  };

  const handleConfirmDelete = () => {
    onDelete();
    setShowConfirmation(false);
  };

  return (
    <div className="space-y-6 self-center md:self-start">
      {restaurant.mainPictureUrl && (
        <section className="h-44 w-80 border rounded-xl">
          <img src={restaurant.mainPictureUrl} alt="main" className="rounded-xl w-full h-full object-cover" />
        </section>
      )}
      {latestSupportComment && (
        <section className="h-fit w-80 border rounded-xl p-5 space-y-1">
          <Typography variant="h4" weight="semibold">
            Raison du refus
          </Typography>
          <div className="bg-red-500 w-fit text-white px-2.5 py-1 font-semibold rounded-lg">{latestSupportComment}</div>
        </section>
      )}
      <section className=" h-fit w-80 border rounded-xl p-5 space-y-5">
        <Typography variant="h4" weight="semibold">
          Historique des actions
        </Typography>
        {restaurant.validationStatusHistory.length > 0 ? (
          <ValidationStatusHistory validationStatusHistory={restaurant.validationStatusHistory} />
        ) : (
          <div className="flex justify-center items-center">
            <span className="text-gray-400">Aucun historique disponible</span>
          </div>
        )}
      </section>

      <section>
        {showConfirmation ? (
          <div className="space-y-2">
            <Typography variant="h5" weight="semibold">
              Êtes-vous sûr de vouloir supprimer ?
            </Typography>
            <div className="flex gap-2">
              <Button onClick={handleConfirmDelete} loading={isLoading} fullWidth color="failure" label="Oui" />
              <Button onClick={handleCancel} loading={isLoading} fullWidth color="neutral" label="Annuler" />
            </div>
          </div>
        ) : (
          <Button onClick={handleDeleteClick} fullWidth color="failure" label="Supprimer la fiche du restaurant" />
        )}
      </section>
    </div>
  );
};
